<template>
  <div class="topbar">
    <div class="flex-space-between" :style="`width:${width}px`">
      <div>
        <span class="addFavorite" @click="addFavorite()"><i class="el-icon-star-off"></i> 收藏本站</span> | 服务热线:400-400-4400
      </div>

      <div v-if="user && user.bizCode.code === '0'">
        {{user.result.name}} 您好！欢迎光临！
        <span class="operate" @click="logout()">[退出]</span> | 会员中心 | 帮助中心
      </div>
      <div v-else>
        <span class="operate" @click="jumpRegistration()">注册</span> |
        <span class="operate" @click="jumpLogin()">登录</span> | 帮助中心
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: ["width"],
  computed: {
    ...mapState(["user"])
  },
  methods: {
    /**
     * 加入收藏
     */
    addFavorite() {
      // var title = document.title;
      // var URL = document.URL;
      // if (document.all) {
      // external.AddToFavoritesBar("http://test.aptoto.com:8113", "易查X-epc");
      // } else if (window.sidebar) {
      //   window.sidebar.addPanel(title, URL, "");
      // }
    },

    /**
     * 跳转到注册界面
     */
    jumpRegistration() {
      this.$router.push("/registration");
    },

    /**
     * 跳转到登录界面
     */
    jumpLogin() {
      this.$router.push("./login");
    },

    /**
     * 退出登录
     */
    logout() {
      this.axios({
        method: "post",
        baseURL: "/login",
        url: "/loginOut"
      }).then(response => {
        if (response.data.bizCode.code === "0") {
          this.$store.commit("logout");
          this.$router.push("/login");
        }
      });
    }
  }
};
</script>


<style lang="scss" scoped>
@import "@/custom.scss";

.topbar {
  height: 30px;
  width: 100%;
  min-width: $min-width;
  background-color: $dark-color;
  font-size: 12px;
  color: $white-color;
  line-height: 30px;

  .addFavorite{
    &:hover{
      cursor: pointer;
    }
    
  }
  .el-icon-star-off {
    color: red;
  }
  .flex-space-between {
    background-color: $dark-color;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .operate {
    &:hover {
      color: $main-color;
      cursor: pointer;
    }
  }
}
</style>

